import React from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { RootState, storeActions } from '../../../store'
import { CurrentSubView, Mode, RecognitionState } from '../../../models/enums'
import SendTextBox from '../../AnswerPanel/SendTextBox'
import VoiceInput from '../../AnswerPanel/VoiceInput'
import ModeButton from './ModeButton'
import MicrophoneButton from '../Common/MicrophoneButton'

interface MobileProps {
  parametersOpened: boolean
  toggleParameters: () => void
}

const Mobile = ({ parametersOpened, toggleParameters }: MobileProps): JSX.Element => {
  const dispatch = useDispatch()
  const hideMenu = useSelector((state: RootState) => state.retorikReducer.configuration.hideMenu)
  const disabledSpeechMode = useSelector((state: RootState) => state.retorikReducer.configuration.disableSpeechMode)
  const disabledTextMode = useSelector((state: RootState) => state.retorikReducer.configuration.disableTextMode)
  const mode = useSelector((state: RootState) => state.speechReducer.mode)
  const appAvailable = useSelector((state: RootState) => state.retorikReducer.appAvailable)

  const toggleMode = (newMode: number): void => {
    // If the parameters are opened, no action
    if (!parametersOpened) {
      if (newMode === Mode.text) {
        dispatch(storeActions.retorik.setCanFocusSendBox(true))
        dispatch(storeActions.speech.setActiveRecognitionState(RecognitionState.ForceClosing))
      } else {
        dispatch(storeActions.retorik.setFromTextToVocal(true))
      }

      dispatch(storeActions.utils.setCurrentSubView(CurrentSubView.none))
      dispatch(storeActions.speech.setMode(newMode))
    }
  }

  const handleDashboardClick = (): void => {
    toggleParameters()
  }

  return (
    <div
      id='retorik-framework-menu'
      className='rf-w-full rf-h-fit rf-max-h-80 rf-flex rf-flex-col-reverse rf-border-t rf-border-t-menuBorder rf-pointer-events-auto'
      style={{
        background: 'linear-gradient(to right, #F8F8FC, #EDEEF3)'
      }}
    >
      {/* Main buttons : text / vocal / parameters */}
      <div
        className={`rf-w-full rf-grid rf-flex-1 rf-h-full ${
          !(disabledSpeechMode || disabledTextMode) ? (hideMenu ? 'rf-grid-cols-2' : 'rf-grid-cols-3') : hideMenu ? 'rf-grid-cols-1' : 'rf-grid-cols-2'
        } rf-min-h-12 rf-grid-rows-1 rf-justify-center rf-items-end`}
      >
        {/* Text */}
        {!disabledTextMode && <ModeButton label='text' selected={parametersOpened ? false : mode === Mode.text} onClick={toggleMode} />}

        {/* Vocal / Microphone */}
        {!disabledSpeechMode &&
          (mode === Mode.vocal ? (
            <div className='rf-py-2 rf-w-full rf-flex rf-justify-center'>
              <MicrophoneButton />
            </div>
          ) : (
            <ModeButton label='vocal' selected={false} onClick={toggleMode} />
          ))}

        {/* Parameters */}
        {!hideMenu && <ModeButton label='dashboard' selected={parametersOpened} onClick={handleDashboardClick} />}
      </div>

      {/* Input textbox */}
      {!parametersOpened && mode === Mode.text && <SendTextBox className='rf-mx-4 rf-mt-2' />}

      {/* Speech interims */}
      {appAvailable && !parametersOpened && mode === Mode.vocal && <VoiceInput className='rf-w-full rf-px-6 rf-py-2 rf-text-center' />}
    </div>
  )
}

export default Mobile
